import { Link } from 'react-router-dom';
import { Alert, PageHeader } from '@pryme/ui';
import { DomainVerifier } from '../components/DomainVerifier';
import { useDev } from '../lib/context';
import { canAdmin } from '../lib/types';

/** Organization-level domain ownership. Production only: sandbox services need no domain. */
export function Domains() {
  const { org, environment, orgDomains, reloadOrgDomains, reloadServices } = useDev();
  if (!org) return <Alert tone="info">Create an organization first using the organization selector in the navigation.</Alert>;
  if (environment !== 'production') {
    return (
      <>
        <PageHeader eyebrow="Organization" title="Domains" />
        <Alert tone="info">
          Sandbox services need no domain: register any HTTPS or <code>http://localhost</code> redirect URI. Domains are verified in Production, once per organization.
        </Alert>
        <Link to="/">Back to dashboard</Link>
      </>
    );
  }
  return (
    <>
      <PageHeader
        eyebrow={`Organization · ${org.display_name}`}
        title="Domains"
        lead="Domains belong to the organization, not to a single service. Prove DNS control once, and every production service of the organization can use the domain and its subdomains for redirect URIs and AP2 merchant websites. People see the verified domain on the Pryme consent screen."
      />
      <section className="p-card" aria-label="Organization domains">
        <DomainVerifier
          orgId={org.id}
          domains={orgDomains}
          canEdit={canAdmin(org.role)}
          onChange={() => {
            void reloadOrgDomains();
            void reloadServices();
          }}
        />
      </section>
      <p className="p-small p-muted">
        DNS proof shows control <em>at verification time</em>; it does not authenticate requests (your signing key's signature does). Pryme re-checks verified domains periodically. If a
        record disappears, the domain goes stale and production services whose redirect URIs depend on it are suspended. A domain that is in use cannot be removed.
      </p>
    </>
  );
}
